import Constant from '@/const';
import axios from 'axios';

const putUnit = async (id, payload) => {
  try {
    const response = await axios.put(
      Constant.apiUrl.concat(`/master/unit/${id}`),
      payload,
    );
    return response;
  } catch (error) {
    this.showErrorAxios(error);
  }
};

export default putUnit;
